export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=f9e6b7f0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/index.vue?vue&type=template&id=f9e6b7f0&scoped=true
// module id = AeZK
// module chunks = 0